<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    @if (dialogRef.data?.title) {
      <div class="modal-header">
        <h1
          class="modal-title fs-5"
          [innerHTML]="dialogRef.data?.title! | translate | safeHtml"
        ></h1>
      </div>
    }
    <div
      class="modal-body fs-5"
      [innerHTML]="dialogRef.data?.message ?? '' | translate | safeHtml"
    ></div>
    @if (hasButtonData) {
      <div class="modal-footer">
        @if (dialogRef.data?.positiveButton) {
          <button
            class="btn btn-primary"
            type="button"
            (click)="onClickPositive()"
          >
            {{
              dialogRef.data?.positiveButton?.text ?? 'BUTTON.Ok' | translate
            }}
          </button>
        }
        @if (dialogRef.data?.negativeButton) {
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="onClickNegative()"
          >
            {{
              dialogRef.data?.negativeButton?.text ?? 'BUTTON.Cancel'
                | translate
            }}
          </button>
        }
        @if (dialogRef.data?.neutralButton) {
          <div class="space"></div>
          <button
            class="btn btn-primary-outline"
            type="button"
            (click)="onClickNeutral()"
          >
            {{
              dialogRef.data?.neutralButton?.text ?? 'BUTTON.Close' | translate
            }}
          </button>
        }
      </div>
    }
  </div>
</div>
